import { Review } from '@/mocks/reviews';

interface StarRatingProps {
  rating: number;
  size?: 'sm' | 'md';
}

export default function StarRating({ rating, size = 'sm' }: StarRatingProps) {
  const iconSize = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <div className="flex items-center gap-0.5" aria-label={`${rating} / 5 puan`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <span key={star} className={`w-3.5 h-3.5 flex items-center justify-center`}>
          <i
            className={`${iconSize} ${
              star <= rating
                ? 'ri-star-fill'
                : 'ri-star-line'
            }`}
            style={star <= rating ? { color: '#eab308' } : { color: '#d1d5db' }}
          ></i>
        </span>
      ))}
    </div>
  );
}